import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import CalendarPage from './pages/CalendarPage';
import Navbar from './components/Navbar'; // Crearemos este componente a continuación
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute'; // Crearemos este componente
import AdminPage from './pages/AdminPage'; // Página para administrador
import ChangePasswordPage from './pages/ChangePasswordPage'; // Página para cambio de contraseña
import ServicesPage from './pages/ServicesPage';
import RegisterPage from './pages/RegisterPage';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ProfilePage from './pages/ProfilePage';
import { SnackbarProvider } from 'notistack';
import NovedadesPage from './pages/NovedadesPage';
import ReservasPage from './pages/ReservasPage';
import { useAuth } from '../src/context/AuthContext';



// Define un tema básico y moderno
const theme = createTheme({
  palette: {
    primary: {
      main: '#0a5083',
    },
    secondary: {
      main: '#dca652',
    },
    background: {
      default: '#eb4912ff',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#13212c', // Texto oscuro
      secondary: '#757575', // Texto secundario
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '2rem',
      marginBottom: '1rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.5rem',
      marginBottom: '0.8rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px', // Botones más redondeados
          textTransform: 'none', // Sin mayúsculas automáticas
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px', // Espacio entre text fields
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px', // Bordes más redondeados para tarjetas
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)', // Sombra suave
        },
      },
    },
  },
});

function App() {


  return (

    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>

        <Router>
          <AuthProvider>
            <div className="App">
              <Navbar /> {/* La barra de navegación se muestra en todas las rutas */}
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/" element={<LoginPage />} /> {/* Ruta por defecto */}

                {/* Rutas protegidas para usuarios autenticados */}
                <Route
                  path="/calendar"
                  element={
                    <ProtectedRoute>
                      <CalendarPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/change-password"
                  element={
                    <ProtectedRoute>
                      <ChangePasswordPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/services"
                  element={
                    <ProtectedRoute>
                      <ServicesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/novedades"
                  element={
                    <ProtectedRoute>
                      <NovedadesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />

                {/* Ruta protegida para administradores */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly={true}> {/* Este componente necesita saber si solo es para admin */}
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reservas"
                  element={
                    <ProtectedRoute adminOnly={true}> {/* Este componente necesita saber si solo es para admin */}
                      <ReservasPage />
                    </ProtectedRoute>
                  }
                />

                {/* Puedes agregar una página 404 aquí */}
                <Route path="*" element={<div>404 - Página no encontrada</div>} />
              </Routes>
            </div>
          </AuthProvider>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>

  );
}

export default App;